import { render, staticRenderFns } from "./createEmailStrategy.vue?vue&type=template&id=11046230&scoped=true&"
import script from "./createEmailStrategy.vue?vue&type=script&lang=js&"
export * from "./createEmailStrategy.vue?vue&type=script&lang=js&"
import style0 from "./createEmailStrategy.vue?vue&type=style&index=0&id=11046230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11046230",
  null
  
)

export default component.exports